const ACTIONS = {
  SET_HOME_INFO: 'SET_HOME_INFO',
  SET_DELIVERY_DATE_INFO: 'SET_DELIVERY_DATE_INFO',
  SET_STORE_LIST: 'SET_STORE_LIST',
  SET_STORE_INFO: 'SET_STORE_INFO',
  UPDATE_REMIND: 'UPDATE_REMIND',
  RECOMMEND_BANNER_VISIBLE: 'RECOMMEND_BANNER_VISIBLE',
  SET_BANNER_THEME: 'SET_BANNER_THEME',
  SCORELL_THEME_OVER: 'SCORELL_THEME_OVER'
};

export default ACTIONS;
